import { render, staticRenderFns } from "./InfoBanner.vue?vue&type=template&id=945fe476"
import script from "./InfoBanner.vue?vue&type=script&lang=js"
export * from "./InfoBanner.vue?vue&type=script&lang=js"
import style0 from "./InfoBanner.vue?vue&type=style&index=0&id=945fe476&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports